import { createContext, SetStateAction, Dispatch } from "react";

import { FormInstance } from "antd";

import { Feature, SelectOption } from "../../../../../../../../../shared/interfaces";
import { PlanType } from "../../../../../shared";
interface StepTwoFormContextProps {
    stepTwoForm:                        FormInstance<any> | undefined;

    activeKey:                          any;
    setActiveKey:                       Dispatch<SetStateAction<any>>;

    tabs:                               Array<any>;
    setTabs:                            Dispatch<SetStateAction<Array<any>>>;
    addNewTab:                          (id?: any) => void;
    duplicateTab:                       (id?: any) => void;
    removeTab:                          (id?: any) => void;

    consortiumFormValues:               any;
    setConsortiumFormValues:            Dispatch<SetStateAction<any>>;

    isPlanTypeADisabled:                boolean;
    isPlanTypeCDisabled:                boolean;
    
    showModal:                          boolean;
    setShowModal:                       Dispatch<SetStateAction<boolean>>;
    
    keyTabToDelete:                     number | null;
    setKeyTabToDelete:                  Dispatch<SetStateAction<number | null>>;

    planOptionsBySelectedPlan:          Array<SelectOption>;
    
    areTabActionsAllowed:               boolean;
    planTypeSelected:                   PlanType;
    setPlanTypeSelected:                Dispatch<SetStateAction<PlanType>>;
    resetTabs:                          (unconfirmedPlanType: PlanType) => void;

    getFeaturesRisks:                   ( planSelected: string, componente: number ) => Promise<Array<Feature>>;
    getFeaturesRiskByPlan:                   (id: number, planSelected: string, componente: number ) => void;

    allFeatures:                        Array<{ plan: string; keyTab: number; features: Array<Feature> }>;
    setAllFeatures:                     Dispatch<SetStateAction<Array<{ plan: string; keyTab: number; features: Array<Feature> }>>>;
}

export const StepTwoFormContext = createContext({} as StepTwoFormContextProps);